<template>
    <router-view />
    <Toast />
    <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { ConfirmDialog, Toast } from 'primevue';

export default {
    name: 'App',
    components: {
        Toast,
        ConfirmDialog
    }
}
</script>

<style>
@import "primeicons/primeicons.css";

/* Reset css */
html,
body {
    width: 100%;
    height: 100%;

    color: #382e27;
    background-color: #ffffff;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    font-family: "Roboto", serif;
    font-optical-sizing: auto;
    font-style: normal;
    font-variation-settings: "wdth" 100;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    color: #382e27;
    font-weight: 500 !important;
}

/* App css */
#app {
    width: 100%;
}

.bg-custom {
    background-color: #f9f6eb !important;
}

.p-tooltip-text {
    font-size: 0.775rem !important;
}
</style>